module.exports = __webpack_public_path__ + "static/media/city.c3b0f87d.svg";